import { render, staticRenderFns } from "./PrestationTypesList.vue?vue&type=template&id=449945a4"
import script from "./PrestationTypesList.vue?vue&type=script&lang=js"
export * from "./PrestationTypesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports